// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-invalid[data-v-476a4509] {\n  padding-bottom: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
